export default "__VITE_ASSET__C$ia_K4c__"